import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Brain, CheckCircle } from 'lucide-react';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    adhdType: '',
    agreeTerms: false
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match');
      return;
    }
    // Store user data
    localStorage.setItem('adhd_user', JSON.stringify({
      email: formData.email,
      name: formData.name,
      adhdType: formData.adhdType,
      loggedIn: true
    }));
    alert('Welcome to ADHD Life Online!');
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-gradient-to-r from-teal-600 to-emerald-600 rounded-full flex items-center justify-center">
                <Brain className="w-8 h-8 text-white" />
              </div>
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Join Our Community</h1>
            <p className="text-gray-600">Create your free account to get started</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 mb-2">Full Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="Your name"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Email Address</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Password</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                required
                minLength="8"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="••••••••"
              />
              <p className="text-sm text-gray-500 mt-1">Minimum 8 characters</p>
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Confirm Password</label>
              <input
                type="password"
                value={formData.confirmPassword}
                onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                placeholder="••••••••"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">I identify as having (optional)</label>
              <select
                value={formData.adhdType}
                onChange={(e) => setFormData({...formData, adhdType: e.target.value})}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
              >
                <option value="">Prefer not to say</option>
                <option value="inattentive">ADHD - Inattentive Type</option>
                <option value="hyperactive">ADHD - Hyperactive/Impulsive Type</option>
                <option value="combined">ADHD - Combined Type</option>
                <option value="undiagnosed">Suspect I have ADHD</option>
                <option value="support">Supporting someone with ADHD</option>
              </select>
            </div>

            <div>
              <label className="flex items-start">
                <input
                  type="checkbox"
                  checked={formData.agreeTerms}
                  onChange={(e) => setFormData({...formData, agreeTerms: e.target.checked})}
                  required
                  className="mr-2 mt-1"
                />
                <span className="text-sm text-gray-700">
                  I agree to the <a href="#" className="text-teal-600">Terms of Service</a> and <a href="#" className="text-teal-600">Privacy Policy</a>
                </span>
              </label>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-teal-600 to-emerald-600 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition"
            >
              Create Account
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              Already have an account?{' '}
              <Link to="/login" className="text-teal-600 font-semibold hover:text-teal-800">
                Log in
              </Link>
            </p>
          </div>

          <div className="mt-6 pt-6 border-t">
            <div className="flex items-start">
              <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5" />
              <p className="text-sm text-gray-600">
                Free forever account with access to community forums and basic resources
              </p>
            </div>
            <div className="flex items-start mt-3">
              <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5" />
              <p className="text-sm text-gray-600">
                No credit card required
              </p>
            </div>
            <div className="flex items-start mt-3">
              <CheckCircle className="w-5 h-5 text-green-500 mr-2 mt-0.5" />
              <p className="text-sm text-gray-600">
                Cancel anytime
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;